const deliveryMethodActionTypes = {
    GET_DELIVERY_METHOD_LIST_SUCCESS: "GET_DELIVERY_METHOD_LIST_SUCCESS",
    GET_DELIVERY_METHOD_LIST_ERROR: "GET_DELIVERY_METHOD_LIST_ERROR",
    GET_FORMAT_METHOD_LIST_SUCCESS: "GET_FORMAT_METHOD_LIST_SUCCESS",
    GET_FORMAT_METHOD_LIST_ERROR: "GET_FORMAT_METHOD_LIST_ERROR",
  };
  
  export default deliveryMethodActionTypes;